import styled from 'styled-components'

export default styled.div`
  position: relative;
  width: 100%;

  .google-pill {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 12px;
    height: 48px;
    width: 100%;
    padding: 0 16px;
    border: solid 1.5px ${ ({ theme }) => theme.colors.grey };
    border-radius: 52px;
    background-color: ${ ({ theme }) => theme.colors.white };
    color: ${ ({ theme }) => theme.colors.black };
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background-color: ${ ({ theme }) => theme.colors.almostWhite };
    }

    img {
      width: 28px;
      height: 28px;
      flex-shrink: 0;
    }
  }

  .google-gsi {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    overflow: hidden;
    /* The layer itself never takes the click: while Google's button is not in it (script blocked,
       still loading) the pill underneath must stay clickable. */
    pointer-events: none;

    /* Google's button is 44px tall and cannot be resized: stretch the (invisible) hit
       area so the whole pill is clickable. */
    > div {
      pointer-events: auto;
      transform: scaleY(1.2);
    }
  }
`
